import BaseViewModel from "./BaseViewModel";

class CommonViewModel extends BaseViewModel {
    
}

export default CommonViewModel;